/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ApiClientConfiguration {
    apiUrl: string;
    apiKey: string = 'ApiKey';
    private authorizationToken: string = null;
    async getAuthorizationToken(): Promise<string> { return this.authorizationToken; };
    setAuthorizationToken(token: string): void { this.authorizationToken = token; };
}

export class ApiClientBase {
    constructor(private configuration: ApiClientConfiguration) { }

    protected async transformOptions(options: any): Promise<any> {
        const token = await this.configuration.getAuthorizationToken();
        if (token != null) {
            options.headers = (options.headers as HttpHeaders).append("authorization", "Bearer " + token);
        } else {
            options.headers = (options.headers as HttpHeaders).append("X-API-Key", this.configuration.apiKey);
        }
        //options = { ...options, transformResponse: (res) => res, responseType: 'json' };
        return options;
    }

    protected getBaseUrl(defultUrl: string) {
        return this.configuration.apiUrl;
    }

    protected transformResult(url: string, res: HttpResponseBase, cb: (res: HttpResponseBase) => Observable<any>): Observable<any> {
        return cb(res);
    }
}

export interface IBuildInfoApiClient {
    /**
     * Returns assembly build info.
     * @return Success
     */
    headInfo(): Observable<void>;
    /**
     * Returns assembly build info.
     * @return Success
     */
    getInfo(): Observable<BuildInfoModel>;
}

@Injectable({
    providedIn: 'root'
})
export class BuildInfoApiClient extends ApiClientBase implements IBuildInfoApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns assembly build info.
     * @return Success
     */
    headInfo(): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("head", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processHeadInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processHeadInfo(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHeadInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns assembly build info.
     * @return Success
     */
    getInfo(): Observable<BuildInfoModel> {
        let url_ = this.baseUrl + "/api/backoffice/v1/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInfo(<any>r));
                } catch (e) {
                    return <Observable<BuildInfoModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BuildInfoModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<BuildInfoModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BuildInfoModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuildInfoModel>(<any>null);
    }
}

export interface IProductReferencesManagementApiClient {
    /**
     * Returns all storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductReferenceDto>;
    /**
     * Creates a new storefront product reference.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    create(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProductReferenceDto | null | undefined): Observable<ProductReferenceDto>;
    /**
     * Returns a storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto>;
    /**
     * Deletes the storefront product reference.
     * @param reference Product reference - external reference to Customer's Canvas product specification, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductReferencesManagementApiClient extends ApiClientBase implements IProductReferencesManagementApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all storefront product references relevant to the specified query parameters.
     * @param storefrontId Storefront identifier.
     * @param productReference (optional) Product reference filter.
    Product reference is an external reference to Customer's Canvas product, e.g online store product identifier.
     * @param productSpecificationId (optional) Customer's Canvas product specification filter.
     * @param productId (optional) Customer's Canvas product filter.
     * @param productLinkId (optional) Customer's Canvas product link filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU filter.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(storefrontId: number, productReference?: string | null | undefined, productSpecificationId?: number | null | undefined, productId?: number | null | undefined, productLinkId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductReferenceDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/product-references?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (productReference !== undefined && productReference !== null)
            url_ += "productReference=" + encodeURIComponent("" + productReference) + "&";
        if (productSpecificationId !== undefined && productSpecificationId !== null)
            url_ += "productSpecificationId=" + encodeURIComponent("" + productSpecificationId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (productLinkId !== undefined && productLinkId !== null)
            url_ += "productLinkId=" + encodeURIComponent("" + productLinkId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductReferenceDto>(<any>null);
    }

    /**
     * Creates a new storefront product reference.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Create operation parameters.
     * @return Success
     */
    create(storefrontId: number, tenantId?: number | null | undefined, body?: CreateProductReferenceDto | null | undefined): Observable<ProductReferenceDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/product-references?";
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
                } catch (e) {
                    return <Observable<ProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <ProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <ProductReferenceCreationConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReferenceDto>(<any>null);
    }

    /**
     * Returns a storefront product reference.
     * @param reference An external reference to Customer's Canvas product, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/product-references/{reference}?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<ProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReferenceDto>(<any>null);
    }

    /**
     * Deletes the storefront product reference.
     * @param reference Product reference - external reference to Customer's Canvas product specification, e.g online store product identifier.
     * @param storefrontId Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(reference: string | null, storefrontId: number, tenantId?: number | null | undefined): Observable<ProductReferenceDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/product-references/{reference}?";
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        if (storefrontId === undefined || storefrontId === null)
            throw new Error("The parameter 'storefrontId' must be defined and cannot be null.");
        else
            url_ += "storefrontId=" + encodeURIComponent("" + storefrontId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
                } catch (e) {
                    return <Observable<ProductReferenceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductReferenceDto>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<ProductReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductReferenceDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductReferenceDto>(<any>null);
    }
}

export interface IProductsManagementApiClient {
    /**
     * Returns all products, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto>;
    /**
     * Creates a new product and returns its description.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) 
     * @return Success
     */
    createProduct(tenantId?: number | null | undefined, body?: CreateProductDto | null | undefined): Observable<ProductDto>;
    /**
     * Returns a product by its identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductDto>;
    /**
     * Deletes a product by its identifier.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    deleteProduct(id: number, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Returns a list of product options.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductOptions(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto>;
    /**
     * Returns a list of product variants.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariants(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDto>;
    /**
     * Returns a product variant.
     * @param id Product identifier.
     * @param productVariantId Product variant identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariant(id: number, productVariantId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductVariantDto>;
    /**
     * Returns a list of product variant designs.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param designCustomFields (optional) Custom attributes dictionary filter for designs. For example: {"public":"true","name":"my item"}
     * @param designPath (optional) Path filter for designs. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDesigns(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, designCustomFields?: string | null | undefined, designPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDesignDto>;
    /**
     * Returns a list of product variant mockups.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param mockupCustomFields (optional) Custom attributes dictionary filter for mockups. For example: {"public":"true","name":"my item"}
     * @param mockupPath (optional) Path filter for mockups. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantMockups(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, mockupCustomFields?: string | null | undefined, mockupPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantMockupDto>;
    /**
     * Returns a list of product variant documents.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for document name partial match.
     * @param documentCustomFields (optional) Custom attributes dictionary filter for documents. For example: {"public":"true","name":"my item"}
     * @param documentPath (optional) Path filter for documents. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDocuments(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, documentCustomFields?: string | null | undefined, documentPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDocumentDto>;
    /**
     * Set product variants price. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants price operation parameters.
     * @return Success
     */
    setProductVariantPrice(id: number, tenantId?: number | null | undefined, body?: SetProductVariantPriceDto | null | undefined): Observable<void>;
    /**
     * Set product variants availability. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants availability operation parameters.
     * @return Success
     */
    setProductVariantAvailability(id: number, tenantId?: number | null | undefined, body?: SetProductVariantAvailabilityDto | null | undefined): Observable<void>;
    /**
     * Set product variants SKU. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants SKU operation parameters.
     * @return Success
     */
    setProductVariantSku(id: number, tenantId?: number | null | undefined, body?: SetProductVariantSkuDto | null | undefined): Observable<void>;
    /**
     * Imports products from a specific CSV file and returns a list of imported products descriptions.
     * @param tenantId (optional) Tenant identifier.
     * @param file (optional) 
     * @return Success
     */
    importProducts(tenantId?: number | null | undefined, file?: FileParameter | null | undefined): Observable<PagedOfProductDto>;
    /**
     * Creates new designs connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product designs connections creation parameters.
     * @return Success
     */
    createDesignsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductDesignConnectionsDto | null | undefined): Observable<void>;
    /**
     * Removes designs connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product designs connections creation parameters.
     * @return Success
     */
    removeDesignsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductDesignConnectionsDto | null | undefined): Observable<void>;
    /**
     * Creates new mockups connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product mockups connections creation parameters.
     * @return Success
     */
    createMockupsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductMockupConnectionsDto | null | undefined): Observable<void>;
    /**
     * Removes mockups connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product mockups connections creation parameters.
     * @return Success
     */
    removeMockupsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductMockupConnectionsDto | null | undefined): Observable<void>;
    /**
     * Creates new documents connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product documents connections creation parameters.
     * @return Success
     */
    createDocumentsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductDocumentConnectionsDto | null | undefined): Observable<void>;
    /**
     * Removes documents connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product documents connections creation parameters.
     * @return Success
     */
    removeDocumentsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductDocumentConnectionsDto | null | undefined): Observable<void>;
    /**
     * Returns all available product personalization workflows.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by personalization workflow name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailablePersonalizationWorkflows(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfPersonalizationWorkflowDto>;
    /**
     * Returns all available product processing pipelines.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by processing pipeline name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableProcessingPipelines(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProcessingPipelineDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductsManagementApiClient extends ApiClientBase implements IProductsManagementApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all products, relevant to the specified query parameters.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tags (optional) List of tags that product should have.
     * @param customFields (optional) Serialized custom fields dictionary filter. For example: {"public":"true","name":"my item"}.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllProducts(skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, sku?: string | null | undefined, tags?: string[] | null | undefined, customFields?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tags !== undefined && tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (customFields !== undefined && customFields !== null)
            url_ += "customFields=" + encodeURIComponent("" + customFields) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllProducts(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProducts(response: HttpResponseBase): Observable<PagedOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductDto>(<any>null);
    }

    /**
     * Creates a new product and returns its description.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) 
     * @return Success
     */
    createProduct(tenantId?: number | null | undefined, body?: CreateProductDto | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateProduct(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateProduct(<any>r));
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Returns a product by its identifier.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProduct(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProduct(<any>r));
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * Deletes a product by its identifier.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    deleteProduct(id: number, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteProduct(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteProduct(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns a list of product options.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductOptions(id: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductOptionDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/options?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductOptions(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductOptions(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductOptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductOptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductOptions(response: HttpResponseBase): Observable<PagedOfProductOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductOptionDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductOptionDto>(<any>null);
    }

    /**
     * Returns a list of product variants.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariants(id: number, productVersionId?: number | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/variants?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariants(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariants(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariants(response: HttpResponseBase): Observable<PagedOfProductVariantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDto>(<any>null);
    }

    /**
     * Returns a product variant.
     * @param id Product identifier.
     * @param productVariantId Product variant identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariant(id: number, productVariantId: number, productVersionId?: number | null | undefined, tenantId?: number | null | undefined): Observable<ProductVariantDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/variants/{productVariantId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVariantId === undefined || productVariantId === null)
            throw new Error("The parameter 'productVariantId' must be defined.");
        url_ = url_.replace("{productVariantId}", encodeURIComponent("" + productVariantId));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariant(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariant(<any>r));
                } catch (e) {
                    return <Observable<ProductVariantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductVariantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariant(response: HttpResponseBase): Observable<ProductVariantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductVariantDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductVariantDto>(<any>null);
    }

    /**
     * Returns a list of product variant designs.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param designCustomFields (optional) Custom attributes dictionary filter for designs. For example: {"public":"true","name":"my item"}
     * @param designPath (optional) Path filter for designs. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDesigns(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, designCustomFields?: string | null | undefined, designPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDesignDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/variant-designs?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (designCustomFields !== undefined && designCustomFields !== null)
            url_ += "designCustomFields=" + encodeURIComponent("" + designCustomFields) + "&";
        if (designPath !== undefined && designPath !== null)
            url_ += "designPath=" + encodeURIComponent("" + designPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantDesigns(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantDesigns(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDesignDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDesignDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantDesigns(response: HttpResponseBase): Observable<PagedOfProductVariantDesignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDesignDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDesignDto>(<any>null);
    }

    /**
     * Returns a list of product variant mockups.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for design name partial match.
     * @param mockupCustomFields (optional) Custom attributes dictionary filter for mockups. For example: {"public":"true","name":"my item"}
     * @param mockupPath (optional) Path filter for mockups. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantMockups(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, mockupCustomFields?: string | null | undefined, mockupPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantMockupDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/variant-mockups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (mockupCustomFields !== undefined && mockupCustomFields !== null)
            url_ += "mockupCustomFields=" + encodeURIComponent("" + mockupCustomFields) + "&";
        if (mockupPath !== undefined && mockupPath !== null)
            url_ += "mockupPath=" + encodeURIComponent("" + mockupPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantMockups(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantMockups(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantMockupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantMockupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantMockups(response: HttpResponseBase): Observable<PagedOfProductVariantMockupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantMockupDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantMockupDto>(<any>null);
    }

    /**
     * Returns a list of product variant documents.
     * @param id Product identifier.
     * @param productVersionId (optional) Product version identifier.
     * @param productVariantId (optional) Product variant identifier.
     * @param search (optional) Search string for document name partial match.
     * @param documentCustomFields (optional) Custom attributes dictionary filter for documents. For example: {"public":"true","name":"my item"}
     * @param documentPath (optional) Path filter for documents. Subfolders included by default.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param options (optional) Defines options filter e.g.: "{ "opt1_id": "opt1_val1_id, opt1_val2_id", "opt2_id": "opt2_val1_id" }".
     * @param productFilterId (optional) Defines special filter based on product filter with specified identifier.
     * @param takeAvailableOnly (optional) Defines special filter for available product variants.
     * @param sku (optional) SKU of linked ecommerce product.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getProductVariantDocuments(id: number, productVersionId?: number | null | undefined, productVariantId?: number | null | undefined, search?: string | null | undefined, documentCustomFields?: string | null | undefined, documentPath?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, options?: string | null | undefined, productFilterId?: number | null | undefined, takeAvailableOnly?: boolean | null | undefined, sku?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProductVariantDocumentDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/variant-documents?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (productVersionId !== undefined && productVersionId !== null)
            url_ += "productVersionId=" + encodeURIComponent("" + productVersionId) + "&";
        if (productVariantId !== undefined && productVariantId !== null)
            url_ += "productVariantId=" + encodeURIComponent("" + productVariantId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (documentCustomFields !== undefined && documentCustomFields !== null)
            url_ += "documentCustomFields=" + encodeURIComponent("" + documentCustomFields) + "&";
        if (documentPath !== undefined && documentPath !== null)
            url_ += "documentPath=" + encodeURIComponent("" + documentPath) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (options !== undefined && options !== null)
            url_ += "options=" + encodeURIComponent("" + options) + "&";
        if (productFilterId !== undefined && productFilterId !== null)
            url_ += "productFilterId=" + encodeURIComponent("" + productFilterId) + "&";
        if (takeAvailableOnly !== undefined && takeAvailableOnly !== null)
            url_ += "takeAvailableOnly=" + encodeURIComponent("" + takeAvailableOnly) + "&";
        if (sku !== undefined && sku !== null)
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductVariantDocuments(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductVariantDocuments(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductVariantDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductVariantDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariantDocuments(response: HttpResponseBase): Observable<PagedOfProductVariantDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductVariantDocumentDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductVariantDocumentDto>(<any>null);
    }

    /**
     * Set product variants price. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants price operation parameters.
     * @return Success
     */
    setProductVariantPrice(id: number, tenantId?: number | null | undefined, body?: SetProductVariantPriceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/set-variant-price?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetProductVariantPrice(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetProductVariantPrice(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetProductVariantPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Set product variants availability. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants availability operation parameters.
     * @return Success
     */
    setProductVariantAvailability(id: number, tenantId?: number | null | undefined, body?: SetProductVariantAvailabilityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/set-variant-availability?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetProductVariantAvailability(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetProductVariantAvailability(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetProductVariantAvailability(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Set product variants SKU. Variants identifiers will be changed.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Set product variants SKU operation parameters.
     * @return Success
     */
    setProductVariantSku(id: number, tenantId?: number | null | undefined, body?: SetProductVariantSkuDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/set-variant-sku?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetProductVariantSku(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetProductVariantSku(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetProductVariantSku(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Imports products from a specific CSV file and returns a list of imported products descriptions.
     * @param tenantId (optional) Tenant identifier.
     * @param file (optional) 
     * @return Success
     */
    importProducts(tenantId?: number | null | undefined, file?: FileParameter | null | undefined): Observable<PagedOfProductDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/import?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportProducts(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportProducts(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportProducts(response: HttpResponseBase): Observable<PagedOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProductDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProductDto>(<any>null);
    }

    /**
     * Creates new designs connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product designs connections creation parameters.
     * @return Success
     */
    createDesignsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductDesignConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/design-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateDesignsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateDesignsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDesignsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Removes designs connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product designs connections creation parameters.
     * @return Success
     */
    removeDesignsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductDesignConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/design-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveDesignsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveDesignsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDesignsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Creates new mockups connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product mockups connections creation parameters.
     * @return Success
     */
    createMockupsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductMockupConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/mockup-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateMockupsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateMockupsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMockupsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Removes mockups connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product mockups connections creation parameters.
     * @return Success
     */
    removeMockupsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductMockupConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/mockup-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveMockupsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveMockupsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveMockupsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Creates new documents connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product documents connections creation parameters.
     * @return Success
     */
    createDocumentsConnections(id: number, tenantId?: number | null | undefined, body?: CreateProductDocumentConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/document-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateDocumentsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateDocumentsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDocumentsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Removes documents connections for a specified product.
     * @param id Product identifier.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Product documents connections creation parameters.
     * @return Success
     */
    removeDocumentsConnections(id: number, tenantId?: number | null | undefined, body?: RemoveProductDocumentConnectionsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/{id}/document-connections?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveDocumentsConnections(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveDocumentsConnections(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDocumentsConnections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns all available product personalization workflows.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by personalization workflow name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailablePersonalizationWorkflows(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfPersonalizationWorkflowDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/available-workflows?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAvailablePersonalizationWorkflows(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAvailablePersonalizationWorkflows(<any>r));
                } catch (e) {
                    return <Observable<PagedOfPersonalizationWorkflowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfPersonalizationWorkflowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailablePersonalizationWorkflows(response: HttpResponseBase): Observable<PagedOfPersonalizationWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfPersonalizationWorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfPersonalizationWorkflowDto>(<any>null);
    }

    /**
     * Returns all available product processing pipelines.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param search (optional) Search string for partial by processing pipeline name.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAvailableProcessingPipelines(skip?: number | null | undefined, take?: number | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfProcessingPipelineDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/products/available-pipelines?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAvailableProcessingPipelines(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAvailableProcessingPipelines(<any>r));
                } catch (e) {
                    return <Observable<PagedOfProcessingPipelineDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfProcessingPipelineDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableProcessingPipelines(response: HttpResponseBase): Observable<PagedOfProcessingPipelineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfProcessingPipelineDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfProcessingPipelineDto>(<any>null);
    }
}

export interface IStorefrontsManagementApiClient {
    /**
     * Returns all storefronts, relevant to the specified query parameters.
     * @param types (optional) Storefront type filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(types?: StorefrontType[] | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontDto>;
    /**
     * Returns a storefront by identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto>;
    /**
     * Deletes an existing storefront by its identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto>;
    /**
     * Creates new custom storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Custom storefront creation model.
     * @return Success
     */
    createCustomStorefront(tenantId?: number | null | undefined, body?: CreateCustomStorefrontDto | null | undefined): Observable<CustomStorefrontDto>;
    /**
     * Returns extended information about custom storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getCustomStorefront(id: number, tenantId?: number | null | undefined): Observable<CustomStorefrontDto>;
    /**
     * Creates new NopCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) NopCommerce storefront creation model.
     * @return Success
     */
    createNopCommerceStorefront(tenantId?: number | null | undefined, body?: CreateNopCommerceStorefrontDto | null | undefined): Observable<NopCommerceStorefrontDto>;
    /**
     * Returns extended information about NopCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getNopCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<NopCommerceStorefrontDto>;
    /**
     * Creates new WooCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) WooCommerce storefront creation model.
     * @return Success
     */
    createWooCommerceStorefront(tenantId?: number | null | undefined, body?: CreateWooCommerceStorefrontDto | null | undefined): Observable<WooCommerceStorefrontDto>;
    /**
     * Returns extended information about WooCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getWooCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<WooCommerceStorefrontDto>;
    /**
     * Creates new Magento storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Magento storefront creation model.
     * @return Success
     */
    createMagentoStorefront(tenantId?: number | null | undefined, body?: CreateMagentoStorefrontDto | null | undefined): Observable<MagentoStorefrontDto>;
    /**
     * Returns extended information about Magento storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getMagentoStorefront(id: number, tenantId?: number | null | undefined): Observable<MagentoStorefrontDto>;
    /**
     * Creates new BigCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) BigCommerce storefront creation model.
     * @return Success
     */
    createBigCommerceStorefront(tenantId?: number | null | undefined, body?: CreateBigCommerceStorefrontDto | null | undefined): Observable<BigCommerceStorefrontDto>;
    /**
     * Returns extended information about BigCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getBigCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<MagentoStorefrontDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StorefrontsManagementApiClient extends ApiClientBase implements IStorefrontsManagementApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns all storefronts, relevant to the specified query parameters.
     * @param types (optional) Storefront type filter.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param search (optional) Search string for partial match.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(types?: StorefrontType[] | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, search?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts?";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfStorefrontDto>(<any>null);
    }

    /**
     * Returns a storefront by identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<StorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontDto>(<any>null);
    }

    /**
     * Deletes an existing storefront by its identifier.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<StorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
                } catch (e) {
                    return <Observable<StorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<StorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StorefrontDto>(<any>null);
    }

    /**
     * Creates new custom storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Custom storefront creation model.
     * @return Success
     */
    createCustomStorefront(tenantId?: number | null | undefined, body?: CreateCustomStorefrontDto | null | undefined): Observable<CustomStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/custom?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateCustomStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateCustomStorefront(<any>r));
                } catch (e) {
                    return <Observable<CustomStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustomStorefront(response: HttpResponseBase): Observable<CustomStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomStorefrontDto>(<any>null);
    }

    /**
     * Returns extended information about custom storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getCustomStorefront(id: number, tenantId?: number | null | undefined): Observable<CustomStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/custom/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCustomStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCustomStorefront(<any>r));
                } catch (e) {
                    return <Observable<CustomStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomStorefront(response: HttpResponseBase): Observable<CustomStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomStorefrontDto>(<any>null);
    }

    /**
     * Creates new NopCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) NopCommerce storefront creation model.
     * @return Success
     */
    createNopCommerceStorefront(tenantId?: number | null | undefined, body?: CreateNopCommerceStorefrontDto | null | undefined): Observable<NopCommerceStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/nopcommerce?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateNopCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateNopCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<NopCommerceStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NopCommerceStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateNopCommerceStorefront(response: HttpResponseBase): Observable<NopCommerceStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NopCommerceStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NopCommerceStorefrontDto>(<any>null);
    }

    /**
     * Returns extended information about NopCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getNopCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<NopCommerceStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/nopcommerce/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetNopCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetNopCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<NopCommerceStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NopCommerceStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNopCommerceStorefront(response: HttpResponseBase): Observable<NopCommerceStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NopCommerceStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NopCommerceStorefrontDto>(<any>null);
    }

    /**
     * Creates new WooCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) WooCommerce storefront creation model.
     * @return Success
     */
    createWooCommerceStorefront(tenantId?: number | null | undefined, body?: CreateWooCommerceStorefrontDto | null | undefined): Observable<WooCommerceStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/woocommerce?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateWooCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateWooCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<WooCommerceStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WooCommerceStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWooCommerceStorefront(response: HttpResponseBase): Observable<WooCommerceStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WooCommerceStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WooCommerceStorefrontDto>(<any>null);
    }

    /**
     * Returns extended information about WooCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getWooCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<WooCommerceStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/woocommerce/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWooCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWooCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<WooCommerceStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WooCommerceStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWooCommerceStorefront(response: HttpResponseBase): Observable<WooCommerceStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WooCommerceStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WooCommerceStorefrontDto>(<any>null);
    }

    /**
     * Creates new Magento storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) Magento storefront creation model.
     * @return Success
     */
    createMagentoStorefront(tenantId?: number | null | undefined, body?: CreateMagentoStorefrontDto | null | undefined): Observable<MagentoStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/magento?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateMagentoStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateMagentoStorefront(<any>r));
                } catch (e) {
                    return <Observable<MagentoStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MagentoStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMagentoStorefront(response: HttpResponseBase): Observable<MagentoStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MagentoStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagentoStorefrontDto>(<any>null);
    }

    /**
     * Returns extended information about Magento storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getMagentoStorefront(id: number, tenantId?: number | null | undefined): Observable<MagentoStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/magento/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMagentoStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMagentoStorefront(<any>r));
                } catch (e) {
                    return <Observable<MagentoStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MagentoStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMagentoStorefront(response: HttpResponseBase): Observable<MagentoStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MagentoStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagentoStorefrontDto>(<any>null);
    }

    /**
     * Creates new BigCommerce storefront.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) BigCommerce storefront creation model.
     * @return Success
     */
    createBigCommerceStorefront(tenantId?: number | null | undefined, body?: CreateBigCommerceStorefrontDto | null | undefined): Observable<BigCommerceStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/bigcommerce?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateBigCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateBigCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<BigCommerceStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BigCommerceStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateBigCommerceStorefront(response: HttpResponseBase): Observable<BigCommerceStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BigCommerceStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BigCommerceStorefrontDto>(<any>null);
    }

    /**
     * Returns extended information about BigCommerce storefront.
     * @param id Storefront identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getBigCommerceStorefront(id: number, tenantId?: number | null | undefined): Observable<MagentoStorefrontDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/storefronts/bigcommerce/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetBigCommerceStorefront(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetBigCommerceStorefront(<any>r));
                } catch (e) {
                    return <Observable<MagentoStorefrontDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MagentoStorefrontDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBigCommerceStorefront(response: HttpResponseBase): Observable<MagentoStorefrontDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MagentoStorefrontDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MagentoStorefrontDto>(<any>null);
    }
}

export interface IUsersManagementApiClient {
    /**
     * Returns a tenant users list.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(tenantId?: number | null | undefined): Observable<PagedOfTenantUserDto>;
    /**
     * Creates a new tenant user.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) User creation model.
     * @return Success
     */
    create(tenantId?: number | null | undefined, body?: CreateTenantUserDto | null | undefined): Observable<TenantUserDto>;
    /**
     * Returns a tenant user by user identifier.
     * @param id User identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<TenantUserDto>;
    /**
     * Deletes an existing tenant user.
     * @param id User identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<void>;
    /**
     * Returns all tenant user roles, relevant to the specified query parameters.
     * @param search (optional) Search string for partial match.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllRoles(search?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfTenantUserRoleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersManagementApiClient extends ApiClientBase implements IUsersManagementApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiClientConfiguration) configuration: ApiClientConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * Returns a tenant users list.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAll(tenantId?: number | null | undefined): Observable<PagedOfTenantUserDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/users?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(<any>r));
                } catch (e) {
                    return <Observable<PagedOfTenantUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfTenantUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedOfTenantUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfTenantUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfTenantUserDto>(<any>null);
    }

    /**
     * Creates a new tenant user.
     * @param tenantId (optional) Tenant identifier.
     * @param body (optional) User creation model.
     * @return Success
     */
    create(tenantId?: number | null | undefined, body?: CreateTenantUserDto | null | undefined): Observable<TenantUserDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/users?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(<any>r));
                } catch (e) {
                    return <Observable<TenantUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <GeneralConflictDto>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserDto>(<any>null);
    }

    /**
     * Returns a tenant user by user identifier.
     * @param id User identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    get(id: number, tenantId?: number | null | undefined): Observable<TenantUserDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/users/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(<any>r));
                } catch (e) {
                    return <Observable<TenantUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TenantUserDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantUserDto>(<any>null);
    }

    /**
     * Deletes an existing tenant user.
     * @param id User identifier.
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    delete(id: number, tenantId?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/backoffice/v1/users/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(<any>r));
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Returns all tenant user roles, relevant to the specified query parameters.
     * @param search (optional) Search string for partial match.
     * @param skip (optional) Defines page start offset from beginning of sorted result list.
     * @param take (optional) Defines page length (how many consequent items of sorted result list should be taken).
     * @param sorting (optional) Defines sorting order of result list e.g.: "Title ASC, LastModified DESC".
     * @param tenantId (optional) Tenant identifier.
     * @return Success
     */
    getAllRoles(search?: string | null | undefined, skip?: number | null | undefined, take?: number | null | undefined, sorting?: string | null | undefined, tenantId?: number | null | undefined): Observable<PagedOfTenantUserRoleDto> {
        let url_ = this.baseUrl + "/api/backoffice/v1/users/roles?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllRoles(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllRoles(<any>r));
                } catch (e) {
                    return <Observable<PagedOfTenantUserRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedOfTenantUserRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<PagedOfTenantUserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PagedOfTenantUserRoleDto>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedOfTenantUserRoleDto>(<any>null);
    }
}

/** Information about a service. */
export interface BuildInfoModel {
    /** Version number. */
    version?: string | null;
    /** Build date (UTC). */
    buildDate?: string | null;
    /** Build configuration (Debug | Release). */
    configuration?: string | null;
    /** Service name. */
    appName?: string | null;
}

/** Available product reference target types. */
export enum ProductReferenceType {
    ProductSpecification = "ProductSpecification",
    Product = "Product",
    ProductLink = "ProductLink",
}

/** DTO class, containing information about storefront product reference. */
export interface ProductReferenceDto {
    /** Product reference is an external reference to Customer's Canvas product, e.g online store product identifier. */
    productReference?: string | null;
    /** Product reference target type. */
    productReferenceType?: ProductReferenceType;
    /** Product reference name, e.g. online store product name. */
    productReferenceName?: string | null;
    /** Customer's Canvas product specification identifier. */
    productSpecificationId?: number;
    /** Customer's Canvas product identifier. */
    productId?: number;
    /** Customer's Canvas product version identifier. */
    productVersionId?: number;
    /** Customer's Canvas product link identifier. */
    productLinkId?: number;
    /** Storefront identifier. */
    storefrontId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront product reference creation date and time. */
    created?: string;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductReferenceDto {
    total?: number;
    items?: ProductReferenceDto[] | null;
}

/** Conflict types. */
export enum ConflictType {
    NameConflict = "NameConflict",
    FolderOverwriteConflict = "FolderOverwriteConflict",
    IdConflict = "IdConflict",
    GeneralConflict = "GeneralConflict",
}

/** Information about operation conflict. */
export interface GeneralConflictDto {
    /** Problem description. */
    description?: string | null;
    /** Coflict type. */
    type?: ConflictType;
}

/** Dto class, containing create operation parameters for storefront product reference. */
export interface CreateProductReferenceDto {
    /** Product reference is an external reference to Customer's Canvas product, e.g online store product identifier. */
    productReference: string;
    /** Product reference target type. */
    productReferenceType?: ProductReferenceType;
    /** Product reference name, e.g. online store product name. */
    productReferenceName?: string | null;
    /** Customer's Canvas product specification identifier. */
    productSpecificationId?: number | null;
    /** Customer's Canvas product identifier. */
    productId?: number | null;
    /** Customer's Canvas product link identifier. */
    productLinkId?: number | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

/** DTO class, containing information about storefront product reference. */
export interface ProductReferenceInfo {
    /** Product reference is an external reference to Customer's Canvas product, e.g online store product identifier. */
    productReference?: string | null;
    /** Product reference target type. */
    productReferenceType?: ProductReferenceType;
    /** Product reference name, e.g. online store product name. */
    productReferenceName?: string | null;
    /** Customer's Canvas product specification identifier. */
    productSpecificationId?: number;
    /** Customer's Canvas product identifier. */
    productId?: number;
    /** Customer's Canvas product link identifier. */
    productLinkId?: number;
    /** Storefront identifier. */
    storefrontId?: number;
}

/** DTO class, containing information about storefront product reference creation conflict. */
export interface ProductReferenceCreationConflictDto {
    /** List of storefront product references, which are already exist. */
    existingReferences?: ProductReferenceInfo[] | null;
    /** Problem description. */
    description?: string | null;
    /** Coflict type. */
    type?: ConflictType;
}

/** Dto class, containing information about a product resource of type image. */
export interface ImageInfo {
    /** Product resource identifier. */
    resourceId?: string | null;
    /** Product Resource URL. */
    url?: string | null;
}

/** Dto class, containing information about a product. */
export interface ProductDto {
    /** Product identifier. */
    id?: number;
    /** Product version identifier. */
    productVersionId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product name. */
    name?: string | null;
    /** Product description. */
    description?: string | null;
    /** Product image info. */
    image?: ImageInfo | null;
    /** Product creation time. */
    created?: string;
    /** Product modification time. */
    lastModified?: string | null;
    /** Product tags. */
    tags?: string[] | null;
    /** Product custom fields. */
    customFields?: { [key: string]: string; } | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number;
    /** Processing pipeline identifier. */
    processingPipelineId?: number;
    /** Default storefront identifier. */
    storefrontId?: number | null;
    /** Default storefront product identifier. */
    storefrontProductId?: string | null;
    /** Default storefront product name. */
    storefrontProductName?: string | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductDto {
    total?: number;
    items?: ProductDto[] | null;
}

/** Product option value creation operation parameters. */
export interface CreateProductOptionValueDto {
    /** Product option value. */
    value?: string | null;
}

/** Product option creation operation parameters. */
export interface CreateProductOptionDto {
    /** Option title. */
    title?: string | null;
    /** Option traits. */
    traits?: string[] | null;
    /** Product option values. */
    values?: CreateProductOptionValueDto[] | null;
    /** Flag that indicates if option can be used for product design connections creation. */
    useForDesignBinding?: boolean;
    /** Flag that indicates if option can be used for product mockup connections creation. */
    useForMockupBinding?: boolean;
    /** Flag that indicates if option can be used for product document connections creation. */
    useForDocumentBinding?: boolean;
}

/** Product option creation operation parameters. */
export interface CreateProductDto {
    /** Product name. */
    name?: string | null;
    /** Product description. */
    description?: string | null;
    /** Personalization workflow identifier. */
    personalizationWorkflowId?: number;
    /** Processing pipeline identifier. */
    processingPipelineId?: number;
    /** Product tags. */
    tags?: string[] | null;
    /** Product custom fields. */
    customFields?: { [key: string]: string; } | null;
    /** Product options parameters. */
    options?: CreateProductOptionDto[] | null;
}

/** Available option types. */
export enum OptionType {
    Simple = "Simple",
    Size = "Size",
    PageCount = "PageCount",
}

/** Available appearance types. */
export enum AppearanceDataType {
    Radio = "Radio",
    Dropdown = "Dropdown",
    Chips = "Chips",
    ColorGrid = "ColorGrid",
    ColorList = "ColorList",
    ImageGrid = "ImageGrid",
    ImageList = "ImageList",
}

/** DTO class, containing information about a product option appearance item. */
export interface AppearanceDataItemDto {
    /** Appearance item key. */
    key?: string | null;
    /** Appearance item value. */
    value?: string | null;
}

/** DTO class, containing information about a product option appearance. */
export interface AppearanceDataDto {
    /** Appearance type. */
    type?: AppearanceDataType;
    /** Appearance items. */
    items?: AppearanceDataItemDto[] | null;
}

/** Option value description for 'Simple' option type. */
export interface SimpleOptionValue {
    /** String Value. */
    value?: string | null;
}

/** DTO class, containing information about a product option value. */
export interface ProductOptionValueDto {
    /** Product option value identifier. */
    id?: number;
    /** Product option value title. */
    title?: string | null;
    /** Product option value sort index. */
    sortIndex?: number;
    /** Indicates if product option value is used as a default value. */
    isDefault?: boolean;
    /** Product option value identifying tag. */
    tag?: string | null;
    /** Product option value description for 'Simple' option type. */
    simpleOptionValue?: SimpleOptionValue | null;
    /** Product option value description. */
    description?: string | null;
    /** Product option value colors. */
    colors?: string[] | null;
    /** Product option value image. */
    image?: ImageInfo | null;
}

/** DTO class, containing information about a product option. */
export interface ProductOptionDto {
    /** Product option identifier. */
    id?: number;
    /** Product version identifier */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Option type ('Simple' / 'Size' / 'PageCount'). */
    type?: OptionType;
    /** Option traits. */
    traits?: string[] | null;
    /** Product option title. */
    title?: string | null;
    /** Product option sort index. */
    sortIndex?: number;
    /** Product option identifying tag. */
    tag?: string | null;
    /** Specifies if the option is used for design binding. */
    useForDesignBinding?: boolean;
    /** Specifies if the option is used for mockup binding. */
    useForMockupBinding?: boolean;
    /** Specifies if the option is used for document binding. */
    useForDocumentBinding?: boolean;
    /** Product option description. */
    description?: string | null;
    /** Product option tooltip. */
    tooltip?: string | null;
    /** Product option appearance. */
    appearanceData?: AppearanceDataDto | null;
    /** Product option image info. */
    image?: ImageInfo | null;
    /** A list of product option values. */
    productOptionValues?: ProductOptionValueDto[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductOptionDto {
    total?: number;
    items?: ProductOptionDto[] | null;
}

/** Dto class, containing information about a product variant option. */
export interface ProductVariantOptionDto {
    /** Product option identifier. */
    productOptionId?: number | null;
    /** Product option value identifier. */
    productOptionValueId?: number | null;
    /** Product option type ('Simple' / 'Size' / 'PageCount'). */
    productOptionType?: OptionType;
    /** Product option traits. */
    productOptionTraits?: string[] | null;
    /** Product option title. */
    productOptionTitle?: string | null;
    /** Product option value title. */
    productOptionValueTitle?: string | null;
    /** Product option value description for 'Simple' option type. */
    simpleOptionValue?: SimpleOptionValue | null;
}

/** DTO class, containing information about a product variant. */
export interface ProductVariantDto {
    /** Product variant identifier. */
    id?: number;
    /** Product variant unique identifier. */
    uid?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductVariantDto {
    total?: number;
    items?: ProductVariantDto[] | null;
}

/** Available product variant resource types. */
export enum ProductVariantResourceType {
    Preview = "Preview",
    EditorModel = "EditorModel",
    Custom = "Custom",
}

/** Product variant resource description for 'Preview' resource type. */
export interface ProductVariantResourcePreview {
    /** Preview with in pixels. */
    width?: number | null;
    /** Preview height in pixels. */
    height?: number | null;
    /** Mockup which is used to create preview. */
    mockupId?: string | null;
    /** Design surface index which is used to create preivew. */
    surfaceIndex?: number | null;
}

/** Dto class, containing information about a product variant resource. */
export interface ProductVariantResourceDto {
    /** Resource identifier. */
    resourceId?: string | null;
    /** Resource name. */
    name?: string | null;
    /** Resource url. */
    url?: string | null;
    /** Resource type. */
    type?: ProductVariantResourceType;
    /** Product variant resource description for 'Preview' resource type. */
    resourcePreview?: ProductVariantResourcePreview | null;
}

/** Dto class, containing information about a product variant design. */
export interface ProductVariantDesignDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Design identifier. */
    designId?: string | null;
    /** Design name. */
    designName?: string | null;
    /** Design grouping tag. */
    designGroup?: string | null;
    /** Design data schema tag. Indicates if design has data schema. */
    designHasDataSchema?: boolean;
    /** Design toggle set tag. Indicated if design has toggle set. */
    designHasToggleSet?: boolean;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
    /** A list of product variant resources. */
    productVariantResources?: ProductVariantResourceDto[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductVariantDesignDto {
    total?: number;
    items?: ProductVariantDesignDto[] | null;
}

/** Available mockup types. */
export enum ProductVariantMockupType {
    Thumbnail = "Thumbnail",
    Editor = "Editor",
    Preview = "Preview",
}

/** Available surface usage types. */
export enum SurfaceUsageType {
    Individual = "Individual",
    Custom = "Custom",
    All = "All",
}

/** Dto class, containing information about a product variant mockup. */
export interface ProductVariantMockupDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number | null;
    /** Product variant identifier in online store (usually SKU). */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Mockup identifier. */
    mockupId?: string | null;
    /** Mockup name. */
    mockupName?: string | null;
    /** Mockup type. */
    mockupType?: ProductVariantMockupType;
    /** Surface index indicates a surface of a design to which mockup should be applied. */
    surfaceIndex?: number | null;
    /** Surface usage type defines a scheme for applying mockup to design surfaces. */
    surfaceUsageType?: SurfaceUsageType;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductVariantMockupDto {
    total?: number;
    items?: ProductVariantMockupDto[] | null;
}

/** DTO class, containing information about a product variant document. */
export interface ProductVariantDocumentDto {
    /** Product variant identifier. */
    productVariantId?: number;
    /** Product variant unique identifier. */
    productVariantUID?: string | null;
    /** Product version identifier. */
    productVersionId?: number;
    /** Product identifier. */
    productId?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Product variant available. */
    isAvailable?: boolean;
    /** Product variant price. */
    price?: number | null;
    /** Product variant sort index. */
    sortIndex?: number;
    /** Product variant identifier (usually SKU) in storefront / online store. */
    storefrontProductVariantId?: string | null;
    /** Product variant SKU. */
    sku?: string | null;
    /** Document identifier. */
    documentId?: string | null;
    /** Document name. */
    documentName?: string | null;
    /** Document grouping tag. */
    documentGroup?: string | null;
    /** A list of product variant options. */
    productVariantOptions?: ProductVariantOptionDto[] | null;
    /** A list of product variant resources. */
    productVariantResources?: ProductVariantResourceDto[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProductVariantDocumentDto {
    total?: number;
    items?: ProductVariantDocumentDto[] | null;
}

/** Parameters for setting product variants price. */
export interface ProductVariantPriceDto {
    /** Price. */
    price?: number | null;
    /** UIDs of variants for price setting. */
    variantUIDs?: string[] | null;
}

/** Product variants price setting operation parameters. */
export interface SetProductVariantPriceDto {
    /** List of product variants grouped by price value. */
    items?: ProductVariantPriceDto[] | null;
}

/** Parameters for setting product variants availability. */
export interface ProductVariantAvailabilityDto {
    /** Availability. */
    availability?: boolean;
    /** UIDs of variants for availability setting. */
    variantUIDs?: string[] | null;
}

/** Product variants availability setting operation parameters. */
export interface SetProductVariantAvailabilityDto {
    /** List of product variants grouped by availability value. */
    items?: ProductVariantAvailabilityDto[] | null;
}

/** Parameters for setting product variants SKU. */
export interface ProductVariantSkuDto {
    /** SKU. */
    sku?: string | null;
    /** UIDs of variants for SKU setting. */
    variantUIDs?: string[] | null;
}

/** Product variants SKU setting operation parameters. */
export interface SetProductVariantSkuDto {
    /** List of product variants grouped by SKU value. */
    items?: ProductVariantSkuDto[] | null;
}

/** Product asset connection options description. */
export interface ProductAssetConnectionOptionsDto {
    /** Product option identifier. */
    optionId?: number;
    /** Product option values identifiers. */
    optionValueIds?: number[] | null;
}

/** Product design connection description. */
export interface ProductDesignConnectionDto {
    /** Design identifier. */
    designId?: string | null;
    /** Connection options. Set empty if design should be available for all product variants. */
    options?: ProductAssetConnectionOptionsDto[] | null;
}

/** Product designs connections creation model. */
export interface CreateProductDesignConnectionsDto {
    /** Connection parameters list. */
    connections?: ProductDesignConnectionDto[] | null;
}

/** Product asset connection removing parameters. */
export interface RemoveProductAssetConnectionDto {
    /** Asset identifier. */
    assetId?: string | null;
    /** Connection options. Set empty if all product variants connections should be removed. */
    options?: ProductAssetConnectionOptionsDto[] | null;
}

/** Product designs connections removing model. */
export interface RemoveProductDesignConnectionsDto {
    /** Connection parameters list. */
    connections?: RemoveProductAssetConnectionDto[] | null;
}

/** Product mockup type. */
export enum ProductMockupType {
    Thumbnail = "Thumbnail",
    Editor = "Editor",
    Preview = "Preview",
}

/** Product mockup connection description. */
export interface ProductMockupConnectionDto {
    /** Mockup identifier. */
    mockupId?: string | null;
    /** Connection options. Set empty if mockup should be available for all product variants. */
    options?: ProductAssetConnectionOptionsDto[] | null;
    /** Product mockup types. Single mockup may be used as editor, preview and thumbnail mockup at the same time. */
    mockupTypes?: ProductMockupType[] | null;
    /** Product mockup target surfaces. Comma-separated surface indexes ("1,2,3") or `all` value may be set. */
    surfaces?: string | null;
}

/** Product mockups connections creation model. */
export interface CreateProductMockupConnectionsDto {
    /** Connection parameters list. */
    connections?: ProductMockupConnectionDto[] | null;
}

/** Product mockups connections removing model. */
export interface RemoveProductMockupConnectionsDto {
    /** Connection parameters list. */
    connections?: RemoveProductAssetConnectionDto[] | null;
}

/** Product document connection description. */
export interface ProductDocumentConnectionDto {
    /** Document identifier. */
    documentId?: string | null;
    /** Connection options. Set empty if document should be available for all product variants. */
    options?: ProductAssetConnectionOptionsDto[] | null;
}

/** Product documents connections creation model. */
export interface CreateProductDocumentConnectionsDto {
    /** Connection parameters list. */
    connections?: ProductDocumentConnectionDto[] | null;
}

/** Product documents connections removing model. */
export interface RemoveProductDocumentConnectionsDto {
    /** Connection parameters list. */
    connections?: RemoveProductAssetConnectionDto[] | null;
}

/** Type of editor that should be configured by workflow. */
export enum WorkflowType {
    UIFramework = "UIFramework",
    SimpleEditor = "SimpleEditor",
    DesignEditor = "DesignEditor",
    WorkflowElements = "WorkflowElements",
}

/** Personalization workflow description DTO. */
export interface PersonalizationWorkflowDto {
    /** Workflow identifier. */
    id?: number;
    /** Workflow name. */
    name?: string | null;
    /** Workflow type. */
    workflowType?: WorkflowType;
}

/** DTO, containing results of paged query. */
export interface PagedOfPersonalizationWorkflowDto {
    total?: number;
    items?: PersonalizationWorkflowDto[] | null;
}

/** Dto class, containing information about processing pipeline details. */
export interface ProcessingPipelineDto {
    /** Processing pipeline identifier. */
    id?: number;
    /** Processing pipeline name. */
    name?: string | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfProcessingPipelineDto {
    total?: number;
    items?: ProcessingPipelineDto[] | null;
}

/** Storefront types. */
export enum StorefrontType {
    Custom = "Custom",
    ShopifyLegacy = "ShopifyLegacy",
    DocketManager = "DocketManager",
    CustomSaml = "CustomSaml",
    NopCommerce = "NopCommerce",
    WooCommerce = "WooCommerce",
    Magento = "Magento",
    BigCommerce = "BigCommerce",
    Shopify = "Shopify",
    ShopifyCustom = "ShopifyCustom",
}

/** Dto class, containing information about a storefront. */
export interface StorefrontDto {
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfStorefrontDto {
    total?: number;
    items?: StorefrontDto[] | null;
}

/** Custom storefront creation model. */
export interface CreateCustomStorefrontDto {
    /** Storefront name. */
    name: string;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Name of header that will be used to provide API key to target storefront system. */
    apiKeyHeaderName?: string | null;
    /** API key for target storefront system. */
    apiKey?: string | null;
    /** List of storefront shops URLs. */
    shopUrls: string[];
}

/** Custom storefront description. */
export interface CustomStorefrontDto {
    /** Name of header that will be used to provide API key to target storefront system. */
    apiKeyHeaderName?: string | null;
    /** API key for target storefront system. */
    apiKey?: string | null;
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** NopCommerce storefront creation model. */
export interface CreateNopCommerceStorefrontDto {
    /** NopCommerce storefront name. */
    name: string;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** List of NopCommerce shops URLs. */
    shopUrls: string[];
    /** NopCommerce back-end application URL. */
    backendUrl: string;
}

/** NopCommerce storefront settings. */
export interface NopCommerceSettingsDto {
    /** Customer's Canvas Asset Storage URL. */
    assetStorageUrl?: string | null;
    /** Customer's Canvas Asset Processor URL. */
    assetProcessorUrl?: string | null;
    /** Customer's Canvas tenant identifier. */
    tenantId?: number;
    /** Customer's Canvas storefront identifier. */
    storefrontId?: number;
    /** Customer's Canvas custom application client identifier. */
    clientId?: string | null;
    /** Customer's Canvas custom application client secret. */
    clientSecret?: string | null;
    /** NopCommerce plugin API key. */
    pluginApiKey?: string | null;
}

/** NopCommerce storefront description. */
export interface NopCommerceStorefrontDto {
    /** NopCommerce storefront settings. */
    settings?: NopCommerceSettingsDto | null;
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** WooCommerce storefront creation model. */
export interface CreateWooCommerceStorefrontDto {
    /** WooCommerce storefront name. */
    name: string;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** List of WooCommerce shops URLs. */
    shopUrls: string[];
    /** WooCommerce back-end application URL. */
    backendUrl: string;
}

/** WooCommerce storefront settings. */
export interface WooCommerceSettingsDto {
    /** Customer's Canvas Asset Storage URL. */
    assetStorageUrl?: string | null;
    /** Customer's Canvas Asset Processor URL. */
    assetProcessorUrl?: string | null;
    /** Customer's Canvas tenant identifier. */
    tenantId?: number;
    /** Customer's Canvas storefront identifier. */
    storefrontId?: number;
    /** Customer's Canvas custom application client identifier. */
    clientId?: string | null;
    /** Customer's Canvas custom application client secret. */
    clientSecret?: string | null;
    /** WooCommerce plugin API key. */
    pluginApiKey?: string | null;
}

/** WooCommerce storefront description. */
export interface WooCommerceStorefrontDto {
    /** WooCommerce storefront settings. */
    settings?: WooCommerceSettingsDto | null;
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** Magento storefront creation model. */
export interface CreateMagentoStorefrontDto {
    /** Storefront name. */
    name: string;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** List of Magento shops URLs. */
    shopUrls: string[];
    /** Magento back-end application URL. */
    backendUrl: string;
    /** Magento API key. */
    shopApiKey: string;
    /** Magento shop code. */
    shopCode?: string | null;
}

/** Magento storefront settings. */
export interface MagentoSettingsDto {
    /** Customer's Canvas Asset Storage URL. */
    assetStorageUrl?: string | null;
    /** Customer's Canvas Asset Processor URL. */
    assetProcessorUrl?: string | null;
    /** Customer's Canvas tenant identifier. */
    tenantId?: number;
    /** Customer's Canvas storefront identifier. */
    storefrontId?: number;
    /** Customer's Canvas custom application client identifier. */
    clientId?: string | null;
    /** Customer's Canvas custom application client secret. */
    clientSecret?: string | null;
}

/** Magento storefront description. */
export interface MagentoStorefrontDto {
    /** Magento storefront settings. */
    settings?: MagentoSettingsDto | null;
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** BigCommerce storefront creation model. */
export interface CreateBigCommerceStorefrontDto {
    /** Storefront name. */
    name: string;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** List of shops URLs. */
    shopUrls: string[];
    /** BigCommerce access token. */
    accessToken: string;
    /** BigCommerce client name. */
    clientName: string;
    /** BigCommerce client identifier. */
    clientId: string;
    /** BigCommerce client secret. */
    clientSecret: string;
    /** BigCommerce integration name. */
    integrationName: string;
    /** BigCommerce API path. */
    apiPath: string;
}

/** BigCommerce storefront settings. */
export interface BigCommerceSettingsDto {
    /** BigCommerce access token. */
    accessToken?: string | null;
    /** BigCommerce client name. */
    bigCommerceClientName?: string | null;
    /** BigCommerce API path. */
    apiPath?: string | null;
    /** BigCommerce client secret. */
    bigCommerceClientSecret?: string | null;
    /** BigCommerce client identifier. */
    bigCommerceClientId?: string | null;
    /** BigCommerce integration name. */
    integrationName?: string | null;
}

/** BigCommerce storefront description. */
export interface BigCommerceStorefrontDto {
    /** BigCommerce integration settings. */
    settings?: BigCommerceSettingsDto | null;
    /** Storefront identifier. */
    id?: number;
    /** Tenant identifier. */
    tenantId?: number;
    /** Storefront name. */
    name?: string | null;
    /** Status of project that should become a trigger to start project items processing automatically. */
    processingPipelinesTriggerProjectStatus?: number | null;
    /** Identifier of pipeline that should be used for post-processing for projects when all project items are processed. */
    postProcessingPipelineId?: number | null;
    /** Storefront ecommerce system type. */
    type?: StorefrontType;
    /** Storefront entity creation date and time. */
    created?: string;
    /** Connected shops URLs. */
    shopUrls?: string[] | null;
}

/** Tenant user description. */
export interface TenantUserDto {
    /** User identifier. */
    id?: number;
    /** User login. */
    login?: string | null;
    /** User email address. */
    email?: string | null;
    /** User first name. */
    firstName?: string | null;
    /** User last name. */
    lastName?: string | null;
    /** User status. */
    isActive?: boolean;
    /** User roles. */
    roleNames?: string[] | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfTenantUserDto {
    total?: number;
    items?: TenantUserDto[] | null;
}

/** Tenant user creation model. */
export interface CreateTenantUserDto {
    /** User login (up to 256 symbols). */
    login: string;
    /** User first name (up to 64 symbols). */
    firstName: string;
    /** User last name (up to 64 symbols). */
    lastName: string;
    /** User email address (up to 256 symbols). */
    email: string;
    /** User status. */
    isActive?: boolean;
    /** User roles (e.g. 'Admin', 'User'). */
    roleNames?: string[] | null;
    /** User password (up to 32 symbols). */
    password: string;
}

/** Tenant user role description. */
export interface TenantUserRoleDto {
    /** Role identifier. */
    id?: number;
    /** Role name. */
    name?: string | null;
}

/** DTO, containing results of paged query. */
export interface PagedOfTenantUserRoleDto {
    total?: number;
    items?: TenantUserRoleDto[] | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}